import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import jsPlumb from 'jsplumb';

// Vue.prototype.jsPlumb = jsPlumb.jsPlumb
Vue.use(jsPlumb)
Vue.use(ViewUI)
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
